import axios from "axios";
import { useState, useTransition } from "react";
import { useAlert } from "../contexts/alertContext";

const axiosInstance = axios.create({
    baseURL: "https://api.japanitip.id",
    headers: {
            "Content-Type": "application/json",
          }, 
    timeout: 30000,
    withCredentials: true
});


axiosInstance.interceptors.response.use(
    (response) => {
        return response;
    },
    (err) => {
        console.log(err)
        if (err.response?.status === 401) {
            return window.location.href = "/login"
        }
        return Promise.reject(err)
    }
);

export const useAxios = ({ session }) => {
    const [ isPending, setIsTransition] = useTransition()
    const [ dataFetch, setDataFetch ] = useState(() => {
        let sessionData = sessionStorage.getItem(session)
        return sessionData ? JSON.parse(sessionData) : []
    })
    const { alertHandler } = useAlert()

    const getData = (path) => {
        // fetch database
        if(dataFetch.length > 0) return
        setIsTransition(async () => {
            try {
                const { data } = await axiosInstance.get(path)
                setDataFetch(data.result)
                sessionStorage.setItem(session, JSON.stringify(data.result))
            } catch (error) {
                console.error(error.message)
            }
        })
    }

    const submitData = (path, data) => {
        // submit to data base
        setIsTransition(async() => {
            try {
                const response = await axiosInstance.post(path, data)
                if (response.status === 201) {
                    setDataFetch((prev) => [...prev, data])
                    sessionStorage.setItem(session, JSON.stringify(response.data.result))
                }
                return alertHandler({ status: 1, message: response.data.message})
            } catch (error) {
                console.error(error.message)
                return null
            }
        })
    }

    const deleteData = (path, _id) => {
        // delete data from database
        setIsTransition(async() => {
            try {
                const response = await axiosInstance.delete(path)
                if (response.status === 200) {
                    let deletedData = dataFetch.filter((items) => items._id !== _id)
                    setDataFetch(deletedData)
                    sessionStorage.setItem(session, JSON.stringify(deletedData))
                    return alertHandler({ status: 1, message: response.data.message})
                }
            } catch (error) {
                console.error(error.message)
                return null
            }
        })
    }

    return { isPending, getData, dataFetch, submitData, deleteData, setDataFetch }
}

export default axiosInstance;
